@if (canUseChat()) {
  <a
    class="chat-notifier"
    routerLink="/admin/chat"
    [class.has-unread]="unreadCount() > 0"
    [attr.aria-label]="'chat.admin.notify' | t"
    [title]="'chat.admin.notify' | t"
  >
    <span class="material-symbols-outlined" aria-hidden="true">notifications</span>
    @if (unreadCount() > 0) {
      <span class="count">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
    }
  </a>
}
